function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.679,
    height: 45.679,
    viewBox: "0 0 45.679 45.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ic_notifications",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Bounds",
    d: "M45.679,0V45.679H0V0Z",
    fill: "none",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16,39a3.838,3.838,0,0,1-3.764-3.9h7.53A3.839,3.839,0,0,1,16,39Zm16-5.849H0V31.2l3.764-3.9V16.574A12.541,12.541,0,0,1,13.177,4.251V2.926a2.825,2.825,0,1,1,5.646,0V4.251a12.543,12.543,0,0,1,9.412,12.324V27.3L32,31.2v1.95Z",
    transform: "translate(6.126 3.264)",
    fill: "#9da1b2",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBold);
export default __webpack_public_path__ + "static/media/Notification_bold.bc03e529afc0b7c36fad6df096d05e16.svg";
export { ForwardRef as ReactComponent };